<template>
  <b-nav align="center" class="lasubnav d-flex align-items-center py-1">   
    <b-nav-item><router-link :to="indexLink" class="text-white" active-class="active">Cajas</router-link></b-nav-item>
    <v-guard :permissions="['CHEQUES']">
    <b-nav-item><router-link :to="chequesdeTercerosLink" class="text-white" active-class="active">Cheques de Terceros</router-link></b-nav-item>
    <b-nav-item><router-link :to="chequesPropiosLink" class="text-white" active-class="active">Cheques Propios</router-link></b-nav-item>
    </v-guard>
    <b-nav-item><router-link :to="cuponesencarteraLink" class="text-white" active-class="active">Cupones en cartera</router-link></b-nav-item>
    <v-guard :permissions="['CAJAS_CATEGORIAS']">
    <b-nav-item><router-link :to="categoriasCajasLink" class="text-white" active-class="active">Categorias Cajas</router-link></b-nav-item>
    </v-guard>
    <BranchofficeSelect v-if="getHasPermission" />
  </b-nav>

</template>

<script>
import BranchofficeSelect from "./../sub-components/branchoffice-select.vue";
export default {
  components: {
    BranchofficeSelect
  },
  data : function () { 
    return {
      hasPermission : false
    }
  },
  computed: {
    getHasPermission() {
        return this.hasPermission
    },
    indexLink() {
      return { name: 'Cajas' }
    },
    categoriasCajasLink() {
      return { name: 'Categorias Cajas' }
    },
    chequesdeTercerosLink() {
      return { name: 'Cheques de Terceros' }
    },
    cuponesencarteraLink() {
      return { name: 'Cupones en cartera' }
    },
    chequesPropiosLink() {
      return { name: 'Cheques Propios' }
    },
  },
  methods: {
    getAllBranchofficesFundsPermission() {
      this.$http
        .get("/api/configs/role/permissions/names", {
           headers: { 
            Authorization: "Bearer " + localStorage.getItem("token")
          },
        })
        .then((response) => {
          this.hasPermission = response.data.data.includes('ACCESS_ALL_BRANCHOFFICES_FUNDS');
        })
    },
  },
  created() {
    this.getAllBranchofficesFundsPermission();
  },
}
</script>

<style scoped>
.lasubnav {
  animation: opacity 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  background: #2d538a;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.active {
  font-weight: bold;
  color: white; 
  background-color: orange;
  border-radius: 10px 10px 0px 0px;
  padding: 11px;
}
</style>